import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface ContractedDataSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const ContractedDataSection = ({
  formData,
  onFieldChange,
}: ContractedDataSectionProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Dados do contratado
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label="Nome"
            name="nomeContratado"
            value={formData.nomeContratado}
            onChange={handleChange}
            size="small"
            helperText="Nome do contratado"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Tipo de documento</InputLabel>
            <Select
              name="tipoDocumentoContratado"
              value={formData.tipoDocumentoContratado}
              label="Tipo de documento"
              onChange={handleSelectChange}
            >
              <MenuItem value="Código na operadora">
                Código na operadora
              </MenuItem>
              <MenuItem value="CNPJ">CNPJ</MenuItem>
              <MenuItem value="CPF">CPF</MenuItem>
            </Select>
            <FormHelperText>Tipo de documento do contratado</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            required
            fullWidth
            label="Número"
            name="numeroDocumentoContratado"
            value={formData.numeroDocumentoContratado}
            onChange={handleChange}
            size="small"
            helperText="Número do documento"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            required
            fullWidth
            label="Número CNES"
            name="cnes"
            value={formData.cnes}
            onChange={handleChange}
            size="small"
            helperText="Código CNES do prestador"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
